var _rect, _g, _path, _path2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo512(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 522,
    viewBox: "0 0 523 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 16,
    fill: "#ddd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487 255.5C487 382.802 383.802 486 256.5 486C129.198 486 26 382.802 26 255.5C26 128.198 129.198 25 256.5 25C383.802 25 487 128.198 487 255.5ZM205.813 255.5C205.813 283.494 228.506 306.187 256.5 306.187C284.494 306.187 307.187 283.494 307.187 255.5C307.187 227.506 284.494 204.813 256.5 204.813C228.506 204.813 205.813 227.506 205.813 255.5Z",
    fill: "#222222"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.837 418.027C370.314 420.164 369.782 423.099 367.611 424.526C335.546 445.604 298.116 457.145 259.684 457.75C219.683 458.38 180.393 447.134 146.783 425.434C113.173 403.734 86.753 372.555 70.8634 335.839C55.5971 300.564 50.7101 261.701 56.7234 223.803C57.1305 221.237 59.5864 219.544 62.1421 220.011L172.081 240.085C174.637 240.552 176.316 243.001 175.999 245.58C174.236 259.886 176.314 274.435 182.062 287.715C188.433 302.438 199.028 314.94 212.505 323.642C225.982 332.343 241.737 336.853 257.777 336.6C272.246 336.372 286.361 332.279 298.673 324.784C300.892 323.433 303.816 323.956 305.293 326.093L368.837 418.027Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 57.9286C256.5 55.3306 258.607 53.2188 261.204 53.2792C305.468 54.3082 348.222 69.8378 382.863 97.5513C417.504 125.265 442.038 163.568 452.758 206.527C453.387 209.048 451.789 211.566 449.254 212.137L340.222 236.665C337.687 237.236 335.184 235.638 334.468 233.141C329.845 217.021 320.325 202.688 307.17 192.164C294.016 181.64 277.943 175.498 261.202 174.526C258.608 174.375 256.5 172.284 256.5 169.686L256.5 57.9286Z",
    fill: "#555555"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 255.5,
    r: 51.7449,
    fill: "#999999"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_80",
    x: 14.2398,
    y: 13.2398,
    width: 508.041,
    height: 508.041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11.7602,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4_80"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.7602,
    dy: 11.7602
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.8801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_80",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo512);
export default __webpack_public_path__ + "static/media/logo512.16a138723f1ae5f3331d9973c7621f36.svg";
export { ForwardRef as ReactComponent };